<template>
  <div>
    <li id="childs-birth-certs" v-if="!noneForSelf">
      <fieldset>
        <legend>
          <span class="label"
            >Do you need to replace birth certificates for your children?</span
          >
          <span class="label"></span>
          <abbr class="required" id="label-childrenCertsReplace" title="(required)">*</abbr>
          <small class="hint"
            >Up to 3 children can be included in this form. For more than 3
            children, complete and submit another application form.</small
          >
        </legend>
        <ul class="choices compact">
          <li>
            <ValidationProvider rules="required:#label-childrenCertsReplace">
              <input
              v-model="form.childrenCertsReplace"
              id="children-certs-yes"
              value="true"
              name="Replace Child Birth Certificates"
              type="radio"
              @change="childrenCertsReplace($event)"
            /><label for="children-certs-yes">Yes</label>
            </ValidationProvider>
          </li>
          <li>
            <input
              v-model="form.childrenCertsReplace"
              id="children-certs-no"
              value="false"
              name="children-certs-replace"
              type="radio"
              @change="childrenCertsReplace($event)"
            /><label for="children-certs-no">No</label>
          </li>
        </ul>
      </fieldset>
    </li>
    <ChildBirthCert
      v-if="form.childrenCertsReplace == 'true'"
      :form="form"
      :index="1"
      @change="updateForm"
    />
    <ChildBirthCert
      v-if="form.childrenCertsReplace == 'true' &&
        form.addAnotherChildToMyApplication1"
      :form="form"
      :index="2"
      @change="updateForm"
    />
    <ChildBirthCert
      v-if="form.childrenCertsReplace == 'true' &&
        form.addAnotherChildToMyApplication1 &&
        form.addAnotherChildToMyApplication2"
      :form="form"
      :index="3"
      @change="updateForm"
    />
  </div>
</template>

<script>
import ChildBirthCert from './components/ChildBirthCert.vue';


export default {
  components: {
    ChildBirthCert
  },
  props: {
    today: String,
    value: Object,
    noneForSelf: Boolean,
  },
  computed: {
    form: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    updateForm(childForm) {
      this.form = { ...this.form, ...childForm };
      // need to wait for the dom to update otherwise the conditions won't work
      setTimeout(() => this.addAnotherChildToMyApplication(), 50);
    },
    childrenCertsReplace() {
      if (this.form.childrenCertsReplace == "true") {
        this.form.certificateOrderProduct.push("child1BirthCertificate")
      } else if (!(this.form.childrenCertsReplace == "true")) {
        this.form.certificateOrderProduct = this.form.certificateOrderProduct
          .filter((product) => !(product.includes("child")))
      }
    },
    addAnotherChildToMyApplication() {
      if (
        this.form.addAnotherChildToMyApplication1 && 
          !this.form.certificateOrderProduct.includes("child2BirthCertificate")
      ) {
        this.form.certificateOrderProduct.push("child2BirthCertificate")
        return;
      } else if (!this.form.addAnotherChildToMyApplication1) {
        this.form.certificateOrderProduct = (this.form.certificateOrderProduct
          .filter(
            (product) =>
              !["child2", "child3"].some((el) => product.includes(el))
          ))
          return;
      }

      if (this.form.addAnotherChildToMyApplication2  && 
      !this.form.certificateOrderProduct.includes("child3BirthCertificate")) {
        this.form.certificateOrderProduct.push("child3BirthCertificate")
        return;
      } else if (!this.form.addAnotherChildToMyApplication2) {
        this.form.certificateOrderProduct = (this.form.certificateOrderProduct
          .filter((product) => !(product === "child3BirthCertificate")));
          return;
      }
    },
  },
};
</script>
